<ion-content class="ion-padding">
  <div class="flex items-center justify-between mb-[10px]">
    <div class="w-[44px] h-[44px] flex justify-center items-center bg-[#FFF3E6] rounded-full">
      <span class="material-symbols-outlined text-[#E98F08]">{{ words.icon }}</span>
    </div>
  </div>

  <div class="text-[20px] font-[700]">{{ words.title | translate }}</div>
  <p class="text-sm">{{ words.introduction | translate }}</p>

  @if (failedToLoad) {
  <p class="text-sm load-failed" style="color: var(--ion-color-danger)">
    {{ 'LEGAL_TEXT_UPDATE.LOAD_FAILED' | translate }}
  </p>
  } @else {
  <div class="policy-html" [innerHTML]="policyHtml"></div>
  }
</ion-content>

@if (failedToLoad) {
<div class="ion-padding">
  <ion-button class="w-full text-base later" (click)="later()">
    {{ 'LEGAL_TEXT_UPDATE.LATER' | translate }}
  </ion-button>
</div>
} @else {
<ion-item lines="none" class="checkbox-item">
  <ion-checkbox slot="start" [(ngModel)]="ticked" [disabled]="!policyHtml"></ion-checkbox>
  <ion-label>{{ words.checkbox | translate }}</ion-label>
</ion-item>

@if (submitFailed) {
<div class="ion-padding-horizontal text-sm" style="color: var(--ion-color-danger)">
  {{ 'TERMS_POLICY_PAGE.ACCEPT_FAILED' | translate }}
</div>
}

<div class="ion-padding">
  <ion-button [disabled]="!ticked || loading" class="w-full text-base submit" (click)="onSubmit()">
    {{ words.button | translate }}
  </ion-button>
</div>
}
